<div class="content-wrapped">
    <!-- Content -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 mb-4 text-primary d-flex justify-content-between align-items-center">
            <span>
                <mat-icon class="me-2 align-middle">store</mat-icon>Promociones
            </span>
            <div>
                <button mat-stroked-button color="accent" class="me-2" matTooltip="Revertir cambios"  (click)="revertChanges()" [disabled]="!hasChanges">Revertir <mat-icon>refresh</mat-icon></button>
                <button *ngIf="hasPermissions('super_promo',null,true)" mat-stroked-button color="primary" class="me-2" matTooltip="Carga de promociones" (click)="openUploadPromotions()">Carga de promociones <mat-icon>upload</mat-icon></button>
                <button mat-stroked-button color="primary" class="me-2" matTooltip="Ver historial de cambios" (click)="openHistoryByCamp(this.id_camp, null, null)">Historial <mat-icon>chat</mat-icon></button>
                <button mat-stroked-button color="primary" class="me-2" matTooltip="Descargar historial de cambios en Excel" (click)="downloadChangeHistory()" [disabled]="isDownloadingHistory">
                  {{ isDownloadingHistory ? 'Generando...' : 'Descargar historial' }} <mat-icon>file_download</mat-icon>
                </button>
            </div>
        </h4>

        <div class="row forced-up">
          <div class="col-md-12 d-flex align-items-center">
             <!-- <button mat-stroked-button color="primary" class="me-2" matTooltip="Agregar nuevas filas de la lista" (click)="addRowsFromList()">Agregar <mat-icon>add</mat-icon></button>-->                

              <!--<button mat-stroked-button color="primary" (click)="downloadTemplate()" matTooltip="Descargar plantilla">Plantilla <mat-icon>file_download</mat-icon></button>-->                 
          </div>
          <div class=" mb-4">
            <br>
            <div class="card-body">

              <div class="row">

                 <div class="col-md-3 col-6 resume-card pointer-click" (click)="selectStatus(0)">
                    <div class="card" [class.selected]="statusSelected === 0">
                      <h6 class="align-middle text-center fs-6 card-header">
                        Promociones
                      </h6>
                      <h4 class="mt-2 text-center">
                        <ng-container>{{ countPromociones }}</ng-container>
                      </h4>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 resume-card pointer-click" (click)="selectStatus(1)">
                    <div class="card" [class.selected]="statusSelected === 1">
                      <h6 class="align-middle text-center fs-6 card-header">
                        Solicitudes pendientes
                      </h6>
                      <h4 class="mt-2 text-center">
                        <ng-container>{{ countPendientes }}</ng-container>
                      </h4>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 resume-card pointer-click" (click)="selectStatus(2)">
                    <div class="card" [class.selected]="statusSelected === 2">
                      <h6 class="align-middle text-center fs-6 card-header">  
                        Solicitudes aprobadas
                      </h6>
                      <h4 class="mt-2 text-center">
                        <ng-container>{{ countAprobadas }}</ng-container>
                      </h4>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 resume-card pointer-click" (click)="selectStatus(3)">
                    <div class="card" [class.selected]="statusSelected === 3">
                      <h6 class="align-middle text-center fs-6 card-header">
                        Solicitudes rechazadas
                      </h6>
                      <h4 class="mt-2 text-center">
                        <ng-container>{{ countRechazadas }}</ng-container>                                
                      </h4>
                    </div>
                  </div>

              </div>
              
            </div>
          </div>

          <mat-tab-group  #tabGroup class="hide-tab-header" animationDuration="150ms">
            <mat-tab label="Principal">
              <div class="d-flex justify-content-between align-items-center mb-2" style="padding-bottom: 25px; padding-top: 25px;">
                <button mat-raised-button color="primary" class="same-height" (click)="goBackProjects()">
                  <mat-icon>arrow_back</mat-icon><span class="nb-text">Atras</span>
                </button>
                <div *ngIf="originalPromotionFile.length > 0">
                  <button mat-stroked-button color="primary" (click)="downloadExcel()" matTooltip="Descargar" class="me-2">Descargar <mat-icon>file_download</mat-icon></button>
                  <!--<button mat-stroked-button color="primary" class="me-2" matTooltip="Carga masiva de nuevas promociones desde un Excel" (click)="fileInput.click()">Carga masiva <mat-icon>file_upload</mat-icon></button>-->
                  <!-- <button *ngIf="!hasPermissions('super_promo',null,true)" mat-stroked-button color="primary" class="me-2" matTooltip="Subir listado de solicitudes de promociones" (click)="fileInput.click()">Subir solicitudes de promociones<mat-icon>file_upload</mat-icon></button> -->
                  <!-- <button *ngIf="hasPermissions('super_promo',null,true)" mat-stroked-button color="primary" class="me-2" matTooltip="Subir listado de cambios de promociones" (click)="fileInput.click()">Subir cambios de promociones<mat-icon>file_upload</mat-icon></button> -->
                  <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept=".xlsx, .xls">
                  <!-- <button  mat-stroked-button color="primary" class="me-2" matTooltip="Agregar nueva fila" (click)="addRow()">Agregar promoción <mat-icon>add</mat-icon></button> -->
                  <!-- <button  mat-raised-button color="primary" (click)="sendSolicitud()"  matTooltip="Solicitar"  [disabled]="!hasChanges" class="me-2">Solicitar <mat-icon>check</mat-icon></button> -->
                  <button  mat-raised-button color="primary" (click)="saveChanges()"  matTooltip="Guardar y aplicar"  [disabled]="!hasChanges" class="me-2"> {{sumResponsable>0 && sumSinResponsable == 0 ? 'Solicitar' : (sumResponsable>0 && sumSinResponsable>0 ? 'Aplicar y solicitar cambios' : 'Aplicar cambios') }} <mat-icon>save</mat-icon> </button>
                </div>
              </div>
              <div [hidden]="originalPromotionFile.length > 0" class="alert alert-info">No hay un archivo de promociones cargado.</div>
              <div [hidden]="originalPromotionFile.length == 0" class="promo-container mat-elevation-z0"
                  style="max-height: 70vh; overflow-y: auto; padding: 10px; padding-left: 0px; padding-right: 0px; border: 1px solid #ccc;">
                  <mat-form-field style="padding-left: 10px;" appearance="standard" class="filter-field">
                      <mat-label><mat-icon>search</mat-icon> Buscar</mat-label>
                      <input matInput (keyup)="applyFilter($event)" placeholder="Ej. 7501058714305" #input>
                  </mat-form-field>
                  <div class="table-responsive text-nowrap" style="overflow-x: auto;">
                  <table mat-table [dataSource]="dspromotionFile" matSort class="mat-elevation-z8" style="width: 100%;">
                      <!-- Dinamic Columns -->
                      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header class="do-jump-line-make-bonito"
                              style="min-width: 170px; margin-left: 14px;">
                              <span style="display: block; height: 33px;">{{column}} </span>
                          </th>
                          <td mat-cell *matCellDef="let row; let i = index" style="min-width: 170px; margin-left: 14px;" [ngClass]="{'non-editable-cell': isRowEditing(row) && !isColumnEditable(column)}">
                              <ng-container *ngIf="!isRowEditing(row) || !isColumnEditable(column)">
                                <div class="d-flex align-items-center">
                                  <span *ngIf="column === 'CODIGO PRINCIPAL' && hasPendingRequest(row)"
                                        class="pending-indicator"
                                        matTooltip="Solicitud pendiente">
                                  </span>
                                  {{row[column.trim()]}}
                                </div>
                              </ng-container>
                              <ng-container *ngIf="isRowEditing(row) && isColumnEditable(column)">
                                  <input class="cell-input" 
                                         [type]="getCellType(row[column.trim()])"                                         
                                         [ngModel]="row[column.trim()] ?? ''" (ngModelChange)="row[column.trim()] = $event">
                              </ng-container>
                          </td>
                      </ng-container>
    
                       <ng-container matColumnDef="check" sticky>
                          <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito" style="min-width: 70px; margin-left: 3px;"></th>
                          <td mat-cell *matCellDef="let row; let i = index;" class="mat-cell-sticky">
                             <input type="checkbox">
                          </td>
                       </ng-container>
                                     
                      <ng-container matColumnDef="acciones" stickyEnd>
                          <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito"
                          style="min-width: 70px; margin-left: 3px; padding-left: 20px; background: #e7e7e7;"> ACCIONES </th>
                          <td mat-cell *matCellDef="let row; let i = index" class="mat-cell-sticky" style="padding-left: 10px; background: #e7e7e7;">
                            <ng-container *ngIf="!isRowEditing(row)">
                                <button mat-icon-button (click)="startEditing(row)" matTooltip="Editar fila" [disabled]="row.status === 'deleted'">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="deleteRow(row)" matTooltip="Eliminar fila" [disabled]="row.status === 'deleted'">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                                <button mat-icon-button *ngIf="(row.status === 'edited' || row.status === 'deleted') && !createdRows.has(row)" (click)="revertRowChanges(row)" matTooltip="Revertir cambios en fila">
                                    <mat-icon>refresh</mat-icon>
                                </button>
                                <button  mat-icon-button matTooltip="Ver historial de promoción" (click)="openHistoryByCamp(this.id_camp, null, row['CODIGO PRINCIPAL'])"><mat-icon>chat</mat-icon></button>
                            </ng-container>
                            <ng-container *ngIf="isRowEditing(row)">
                                <button mat-icon-button style="color: #2e7d32" (click)="acceptRowChanges(row)" matTooltip="Guardar Cambios">
                                    <mat-icon>check_circle</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="revertRowChanges(row)" matTooltip="Cancelar edición">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </ng-container>
                          </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: allColumns;" [ngClass]="getRowClass(row)"></tr>
                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" colspan="4">No hay datos que coincidan con el filtro "{{input.value}}"</td>
                      </tr>
                  </table>
                  </div>
                  <div *ngIf="!isLoading"
                      style="display: flex; justify-content: center; align-items: center; background: white;">
                  </div>
                  <mat-paginator class="sticky-paginator" [pageSizeOptions]="[10, 25, 100]" #paginator></mat-paginator>
              </div>
            </mat-tab>
            <mat-tab label="Solicitudes">
              <div class="d-flex justify-content-between align-items-center mb-2" style="padding-bottom: 25px; padding-top: 25px;">
                <button mat-raised-button color="primary" class="same-height" (click)="goBackProjects()">
                  <mat-icon>arrow_back</mat-icon><span class="nb-text">Atras</span>
                </button>
                <div>
                  <button *ngIf="hasPermissions('super_promo',null,true) && statusSelected == 1"  mat-stroked-button color="warn" class="me-2" matTooltip="Rechazar Seleccionados" (click)="rejectMultiple()" [disabled]="selectedSolicitudes.size === 0">Rechazar <mat-icon>highlight_off</mat-icon></button>
                  <button *ngIf="hasPermissions('super_promo',null,true) && statusSelected == 1"  mat-raised-button color="primary"  matTooltip="Aceptar Seleccionados" (click)="acceptMultiple()" [disabled]="selectedSolicitudes.size === 0">Aceptar <mat-icon>check</mat-icon></button>
                </div>
              </div>
              <div *ngIf="countPendientes == 0 && statusSelected == 1  ||  countAprobadas == 0 &&  statusSelected == 2 || countRechazadas == 0 && statusSelected == 3" class="alert alert-info"> {{ statusSelected == 1 ? 'No hay solicitudes pendientes' : 
                  statusSelected == 2 ? 'No hay solicitudes aprobadas' : 'No hay solicitudes rechazadas'
                }}</div>
              <div [hidden]="countPendientes == 0 && statusSelected == 1  ||  countAprobadas == 0 &&  statusSelected == 2 || countRechazadas == 0 && statusSelected == 3"
                  class="promo-container mat-elevation-z0"
                  style="max-height: 70vh; overflow-y: auto; padding: 10px; padding-left: 0px; padding-right: 0px; border: 1px solid #ccc;">
                  <mat-form-field style="padding-left: 10px;" appearance="standard" class="filter-field">
                    <mat-label><mat-icon>search</mat-icon> Buscar</mat-label>
                    <input matInput (keyup)="applySolicitudesFilter($event)" placeholder="Ej. 7501058714305" [(ngModel)]="solicitudesFilterValue">
                  </mat-form-field>
                  <div class="table-responsive text-nowrap" style="overflow-x: auto;">
                  <table mat-table [dataSource]="dsSolicitudes" class="mat-elevation-z8" style="width: 100%;">

                    <!-- Columna de Checkbox -->
                    <ng-container matColumnDef="solicitud_select" sticky>
                      <th mat-header-cell *matHeaderCellDef class="solicitud-select-cell">
                        <input *ngIf="hasPermissions('super_promo',null,true) && statusSelected == 1" type="checkbox" (change)="toggleSelectAllSolicitudes()" [checked]="isAllSolicitudesSelected()">
                      </th>
                      <td mat-cell *matCellDef="let solicitud" class="solicitud-select-cell">
                        <input *ngIf="hasPermissions('super_promo',null,true) && statusSelected == 1" type="checkbox" (change)="toggleSolicitudSelection(solicitud)" [checked]="isSolicitudSelected(solicitud)">
                      </td>
                    </ng-container>
                    
                    <!-- Columna Solicitante -->
                    <ng-container matColumnDef="nombre_usuario">
                      <th mat-header-cell *matHeaderCellDef style="padding-left:10px"> Solicitante </th>
                      <td mat-cell *matCellDef="let solicitud" class="solicitante-cell">
                        <div *ngIf="solicitud.tipo !== 1">{{ solicitud.nombre_usuario }}</div>
                        <div *ngIf="solicitud.tipo === 1" style="display: flex; align-items: center; height: 100%;">{{ solicitud.nombre_usuario }}</div>
                      </td>
                    </ng-container>

                    <!-- Columnas Dinámicas -->
                    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                      <th style="min-width: 170px; padding-left: 14px;" mat-header-cell *matHeaderCellDef> {{column}} </th>
                      <td style="min-width: 170px; padding-left: 14px;"  mat-cell *matCellDef="let solicitud">
                        <!-- TIPO 2: CREADO -->
                        <ng-container *ngIf="solicitud.tipo === 2">
                          {{ solicitud.extra_data?.[column] }}
                        </ng-container>
                        <!-- TIPO 3: ELIMINADO -->
                        <ng-container *ngIf="solicitud.tipo === 3">
                          {{ solicitud.extra_data?.[column] }}
                        </ng-container>
                        <!-- TIPO 1: EDITADO -->
                        <ng-container *ngIf="solicitud.tipo === 1">
                          <div class="edited-cell-new">
                            <ng-container *ngIf="getChange(solicitud, column) as change; else originalValue">
                              <span *ngIf="change.estatus === 0" class="pending-change">
                                <input *ngIf="hasPermissions('super_promo',null,true)" type="checkbox" 
                                       class="solicitud-checkbox"
                                       [checked]="isChangeSelected(solicitud, change)"
                                       (change)="toggleChangeSelection(solicitud, change)"> {{ change.valor_nuevo }}
                              </span>
                              <strong *ngIf="change.estatus === 1" class="approved-change">{{ change.valor_nuevo }}</strong>
                              <strong *ngIf="change.estatus === 2" class="rejected-change">{{ change.valor_nuevo }}</strong>
                            </ng-container>
                            <ng-template #originalValue>
                              {{ solicitud.original_info?.[column] }}
                            </ng-template>
                          </div>
                          <div class="edited-cell-original">
                            {{ getChange(solicitud, column) && getChange(solicitud, column).estatus == 1 ? getChange(solicitud, column).valor_actual : solicitud.original_info?.[column] }} 
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>

                    <!-- Columna Acciones -->
                    <ng-container matColumnDef="solicitud_acciones" stickyEnd>
                      <th mat-header-cell *matHeaderCellDef class="do-jump-line-make-bonito"
                          style="min-width: 70px; margin-left: 3px; padding-left: 20px; background: #e7e7e7;"> ACCIONES </th>
                      <td mat-cell style="padding-left: 10px; background: #e7e7e7;" *matCellDef="let solicitud">
                        <button *ngIf="hasPermissions('super_promo',null,true) && statusSelected ==1" mat-icon-button style="color: #2e7d32" (click)="acceptRow(solicitud)"  matTooltip="Aceptar">
                          <mat-icon>check_circle_outline</mat-icon>
                        </button>
                        <button  *ngIf="hasPermissions('super_promo',null,true) && statusSelected ==1" mat-icon-button color="warn" (click)="rejectRow(solicitud)" matTooltip="Rechazar">
                          <mat-icon>highlight_off</mat-icon>
                        </button>
                         <button  mat-icon-button (click)="openHistoryByCamp(this.id_camp, null, solicitud.codigo)" matTooltip="Historial">
                          <mat-icon>chat</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="solicitudesColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: solicitudesColumns;" [ngClass]="getSolicitudRowClass(row)"></tr>
                  </table>
                  </div>
                  <mat-paginator class="sticky-paginator" [pageSizeOptions]="[10, 25, 100]" #solicitudesPaginator></mat-paginator>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
    </div>
</div>
